import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

import type { AllLanguagesLanguage } from './types'

const AppProviders = lazy(() => import('@app/components/AppProviders'))
const ProjectsListContainer = lazy(() =>
	import('./components/ProjectsList/ProjectsListContainer').then((module) => ({
		default: module.ProjectsListContainer,
	})),
)

class ProjectListWebComponent extends ReactWebComponent {
	static get observedAttributes() {
		return ['all-languages', 'is-team-admin', 'is-in-user-group', 'is-portal-member']
	}

	override render() {
		const allLanguages = this.jsonProp<AllLanguagesLanguage[]>('all-languages') ?? []
		const isTeamAdmin = this.prop('is-team-admin') === 'true'
		const isInUserGroup = this.prop('is-in-user-group') === 'true'
		const isPortalMember = this.prop('is-portal-member') === 'true'

		return (
			<AppProviders>
				<ProjectsListContainer
					allLanguages={allLanguages}
					isTeamAdmin={isTeamAdmin}
					isInUserGroup={isInUserGroup}
					isPortalMember={isPortalMember}
				/>
			</AppProviders>
		)
	}
}

customElements.define('project-list', ProjectListWebComponent)
